// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"653edd39","453":"79cda410","732":"7770a81c","977":"690d4e65"}[chunkId] + ".chunk.js";
};